<template>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="hide" scrollable>
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">
                    {{ editMode ? 'mdi-account-outline' : 'mdi-account-plus-outline' }}
                </v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Agregar' }} Usuario
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer/>
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" v-if="isClientUser">
                        <kimsa-select
                            @change="clients = $event"
                            :value="clients"
                            :items="clientOptions"
                            item-text="name"
                            item-value="id"
                            label="Clientes asignados"
                            placeholder="Seleccionar clientes"
                            bolder-label
                            multiple
                            outlined solo
                            flat dense
                        />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field
                            label="Nombre del Usuario"
                            placeholder="Ingresar Nombre"
                            bolder-label
                            outlined solo
                            flat dense
                            force-value
                            :value="name"
                            @change="name = $event"
                        />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field
                            label="Email del usuario"
                            placeholder="Email"
                            bolder-label
                            outlined dense
                            force-value
                            inputMode="email"
                            :value="email"
                            @change="email = $event"
                        />
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn @click="editMode ? editUser() : saveUser()" tile color="primary" depressed
                               :disabled="!valid || loadingDelete" :loading="loading">
                            {{ editMode ? 'GUARDAR' : 'AGREGAR' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

import {mapMutations, mapState} from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import Axios from "@/utils/Axios";
import KimsaSelect from '../common/inputs/KimsaSelect.vue';

export default {
    name: "CreateUserDialog",
    components: {KimsaTextField, KimsaSelect},
    props: {
        isClientUser: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            loadingDelete: false,
            editMode: false,
            user: null,
            name: '',
            email: '',
            clientOptions: [],
            clients: [],
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            return !!vm.name && vm.validEmail(vm.email)
        }
    },
    async mounted () {
        const vm = this;
        await vm.loadClients();
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.name = ''
            vm.email = ''
            vm.clients = []
        },
        async loadClients() {
            const vm = this;
            await Axios.get('clients').then(res => {
                vm.clientOptions = res.data.result.clients.map(client => {
                    return {
                        id: client.id,
                        name: client.name,
                    }
                })
            }).catch(er => {
                console.log('error loadClients', er)
            })
        },
        async loadUser(id) {
            const vm = this
            await Axios.get(`user/${id}`).then(res => {
                // console.log('res loadUser', res)
                vm.user = res.data.result.user
                vm.editMode = true
                vm.name = vm.user.name
                vm.email = vm.user.email
                vm.clients = vm.user.clients
                vm.show()
            }).catch(er => {
                console.log('error loadUser', er)
            })
        },
        async saveUser() {
            const vm = this
            vm.loading = true
            // console.log('saveUser', vm)

            let payload = {
                role_id: vm.isClientUser ? 3 : 2, // CLIENT || AMB
                name: vm.name,
                email: vm.email,
            }

            if (vm.isClientUser) {
                payload.clients = vm.clients
            }

            // console.log('payloads save', payload)

            await Axios.post('user/new', payload).then(res => {
                // console.log('res saveUser',res)
                vm.toast('Usuario creado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error saveUser', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        async editUser() {
            const vm = this
            vm.loading = true

            // console.log('editUser', vm)

            let payload = {
                name: vm.name,
                email: vm.email,
            }

            if (vm.isClientUser) {
                payload.clients = vm.clients
            }

            // console.log('payload edit', payload)

            await Axios.patch(`user/${vm.user.id}/edit`, payload).then(res => {
                // console.log('res editUser',res)
                vm.toast('Usuario editado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error editUser', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        validEmail(email) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(email) || false
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.label {
    font-size: 15px;
    color: #333333;
}

</style>